/**
 * Created by JIocb on 22.05.2017.
 */
namespace Factive.Game {
    import List = Factive.Core.Linq.List;
    export class ScorePredictor {
        public constructor() {

        }

        public calculate(dices: Array<DiceData>, combinationType: number/*ScoreCombinationType*/) {

            // let dicesList = new List<DiceData>(dices);
            // //let resultColors = dicesList.Select(o => o.color).ToArray();
            // let resultValues = dicesList.Select(o => o.value).ToArray();
            //
            // //console.log("calculate colors", resultColors.join(","));
            // console.log("calculate values", resultValues.join(","));

            switch (combinationType) {
                case ScoreCombinationType.Ones: {
                    return this.checkOnesBox(dices);
                }
                case ScoreCombinationType.Twos: {
                    return this.checkTwosBox(dices);
                }
                case ScoreCombinationType.Threes: {
                    return this.checkThreesBox(dices);
                }
                case ScoreCombinationType.Fours: {
                    return this.checkFoursBox(dices);
                }
                case ScoreCombinationType.Fives: {
                    return this.checkFivesBox(dices);
                }
                case ScoreCombinationType.Sixes: {
                    return this.checkSixesBox(dices);
                }
                case ScoreCombinationType.TheSame3Kind: {
                    return this.checkIf3Kind(dices);
                }
                case ScoreCombinationType.TheSame4Kind: {
                    return this.checkIf4Kind(dices);
                }
                case ScoreCombinationType.TheSame5Kind: {
                    return this.checkIf5Kind(dices);
                }
                case ScoreCombinationType.FullHouse: {
                    return this.checkIfFullHouse(dices);
                }
                case ScoreCombinationType.Straight: {
                    return this.checkIfStraight(dices);
                }
                case ScoreCombinationType.SmallStraight: {
                    return this.checkIfSmallStaight(dices);
                }
                case ScoreCombinationType.Chance: {
                    return this.checkIfChance(dices);
                }
            }
        }
        public checkOnesBox(dices: Array<DiceData>):number
        {
            if(!dices || dices.length == 0) return 0;

            var tempNum:number = 0;
            for (var i:number = 0; i < 5; i++)
            {
                if ((dices[i].value) == 1)
                {
                    tempNum++;
                }
            }
            return tempNum;
        }
        //twos
        public checkTwosBox(dices: Array<DiceData>): number {
            if(!dices || dices.length == 0) return 0;

            var tempNum: number = 0;
            for (var i: number = 0; i < 5; i++) {
                if ((dices[i].value) == 2) {
                    tempNum += 2;
                }
            }
            return tempNum;
        }

        //threes
        public checkThreesBox(dices: Array<DiceData>): number {
            if(!dices || dices.length == 0) return 0;

            var tempNum: number = 0;
            for (var i: number = 0; i < 5; i++) {
                if ((dices[i].value) == 3) {
                    tempNum += 3;
                }
            }
            return tempNum;
        }

        //fours
        public checkFoursBox(dices: Array<DiceData>): number {
            if(!dices || dices.length == 0) return 0;

            var tempNum: number = 0;
            for (var i: number = 0; i < 5; i++) {
                if ((dices[i].value) == 4) {
                    tempNum += 4;
                }
            }
            return tempNum;
        }

        //fives
        public checkFivesBox(dices: Array<DiceData>): number {
            if(!dices || dices.length == 0) return 0;

            var tempNum: number = 0;
            for (var i: number = 0; i < 5; i++) {
                if ((dices[i].value) == 5) {
                    tempNum += 5;
                }
            }
            return tempNum;
        }

        //sixes
        public checkSixesBox(dices: Array<DiceData>): number {
            if(!dices || dices.length == 0) return 0;

            var tempNum: number = 0;
            for (var i: number = 0; i < 5; i++) {
                if ((dices[i].value) == 6) {
                    tempNum += 6;
                }
            }
            return tempNum;
        }

        //////////////////these are functions for the lower section of the score card
        //if 5 of a kind
        public checkIf5Kind(dices: Array<DiceData>): number {
            if(!dices || dices.length == 0) return 0;

            for (var i: number = 0; i < 5; i++) {
                if ((dices[i].value) != dices[0].value) {
                    //if not 5 of a kind
                    return 0;
                }
            }
            //if 5 of a kind
            return 50;

        }

        //////////////////

        //if 4 of a kind
        public checkIf4Kind(dices: Array<DiceData>): number {
            if(!dices || dices.length == 0) return 0;

            var nCounter: number = 0
            for (var i: number = 0; i < 5; i++) {
                if (dices[i].value == dices[0].value) {
                    nCounter++
                }
                if (dices[i].value == dices[1].value) {
                    nCounter++
                }
                if (dices[i].value == dices[2].value) {
                    nCounter++
                }
                if (dices[i].value == dices[3].value) {
                    nCounter++
                }
                if (dices[i].value == dices[4].value) {
                    nCounter++
                }

                if (nCounter < 4)
                    nCounter = 0;
                if (nCounter >= 4)
                    return ((dices[0].value) + (dices[1].value) + (dices[2].value) + (dices[3].value) + (dices[4].value));
            }
            //if not 4 of a kind
            return 0;

        }

        //////////////////////////////////

        //if 3 of a kind
        public checkIf3Kind(dices: Array<DiceData>): number {
            if(!dices || dices.length == 0) return 0;

            var nCounter: number = 0
            for (var i: number = 0; i < 5; i++) {
                if (dices[i].value == dices[0].value) {
                    nCounter++
                }
                if (dices[i].value == dices[1].value) {
                    nCounter++
                }
                if (dices[i].value == dices[2].value) {
                    nCounter++
                }
                if (dices[i].value == dices[3].value) {
                    nCounter++
                }
                if (dices[i].value == dices[4].value) {
                    nCounter++
                }

                if (nCounter < 3)
                    nCounter = 0;
                if (nCounter >= 3)
                    return ((dices[0].value) + (dices[1].value) + (dices[2].value) + (dices[3].value) + (dices[4].value));
            }
            //if not 3 of a kind

            return 0;

        }

        /////////////////////////
        // if chance
        public checkIfChance(dices: Array<DiceData>): number {
            if(!dices || dices.length == 0) return 0;

            //add total of dice
            return ((dices[0].value) + (dices[1].value) + (dices[2].value) + (dices[3].value) + (dices[4].value))
        }

        ///////////////////////////
        //if full house
        public checkIfFullHouse(dices: Array<DiceData>): number {
            if(!dices || dices.length == 0) return 0;

            for (var i: number = 0; i < 5; i++) {
                var nCounter: number = 0;
                var tempHolder1: number = 8 //ok AS3 doesn't like it set to null I choose 8 cause it is my favorite number and a number that can't be set by the dice array
                var tempHolder2: number = 8
                if (dices[i].value == dices[0].value) {
                    nCounter++
                }
                else {
                    if (tempHolder1 == 8) {
                        tempHolder1 = dices[0].value
                    }
                    else {
                        tempHolder2 = dices[0].value
                    }
                }
                //compare numbers if they are not equal- hold them so they can be compared later
                ///////////////////////////////////
                if (dices[i].value == dices[1].value) {
                    nCounter++
                }
                else {
                    if (tempHolder1 == 8) {
                        tempHolder1 = dices[1].value
                    }
                    else {
                        tempHolder2 = dices[1].value
                    }
                }
                ////////////////////////////////
                if (dices[i].value == dices[2].value) {
                    nCounter++
                }
                else {
                    if (tempHolder1 == 8) {
                        tempHolder1 = dices[2].value
                    }
                    else {
                        tempHolder2 = dices[2].value
                    }
                }
                /////////////////////////////////
                if (dices[i].value == dices[3].value) {
                    nCounter++
                }
                else {
                    if (tempHolder1 == 8) {
                        tempHolder1 = dices[3].value
                    }
                    else {
                        tempHolder2 = dices[3].value
                    }
                }
                /////////////////////////////////////
                if (dices[i].value == dices[4].value) {
                    nCounter++
                }
                else {
                    if (tempHolder1 == 8) {
                        tempHolder1 = dices[4].value
                    }
                    else {
                        tempHolder2 = dices[4].value
                    }
                }

                if (nCounter < 3) {
                    nCounter = 0
                    tempHolder1 = 8
                    tempHolder2 = 8
                }
                if (nCounter == 3) {
                    //figure out the two that are left and see if they are equal too
                    if (tempHolder1 == tempHolder2) {
                        return 25
                    }
                    else {
                        return 0
                    }

                }
                if (nCounter == 5) {
                    //if all numbers are the same this is technecally a full house too
                    return 25
                }

            }
            //if less then 3 are matching
            return 0
        }

        ////////////////////////////
        //if straight
        public checkIfStraight(dices: Array<DiceData>): number {
            if(!dices || dices.length == 0) return 0;

            let dicesList = new List<DiceData>(dices).OrderBy(v => v.value).ToList().Select(v => v.value).Distinct().ToArray();

            if(dicesList.length >= 5){
                for (let i = 0; i < dicesList.length - 1; i++) {
                    let diff = dicesList[i+1] - dicesList[i];
                    if(diff == 0 || diff > 1){
                        return 0;
                    }
                }
            }else {
                return 0;
            }
            return 40;

            // if(!dices || dices.length == 0) return 0;
            //
            // var blnOne: Boolean = false;
            // var blnSix: Boolean = false;
            // var i: number;
            // for (i = 0; i < 5; i++) {
            //     if (dices[i].value == dices[0].value) {
            //         if (i != 0) {
            //             return 0;
            //         }
            //     }
            //     if (dices[i].value == dices[1].value) {
            //         if (i != 1) {
            //             return 0;
            //         }
            //     }
            //     if (dices[i].value == dices[2].value) {
            //         if (i != 2) {
            //             return 0;
            //         }
            //     }
            //     if (dices[i].value == dices[3].value) {
            //         if (i != 3) {
            //             return 0;
            //         }
            //     }
            //     if (dices[i].value == dices[4].value) {
            //         if (i != 4) {
            //             return 0;
            //         }
            //     }
            // }
            //
            // for (i = 0; i < 5; i++) {
            //     if (dices[i].value == 1) {
            //         blnOne = true;
            //     }
            //     if (dices[i].value == 6) {
            //         blnSix = true;
            //     }
            // }
            //
            // if (blnSix == true && blnOne == true) {
            //     return 0;
            // }
            // else {
            //     return 40
            // }
        }

        //////////////////////////
        //if small straight
        public checkIfSmallStaight(dices: Array<DiceData>): number {
            if(!dices || dices.length == 0) return 0;

            let dicesList = new List<DiceData>(dices).OrderBy(v => v.value).ToList().Select(v => v.value).Distinct().ToArray();

            if(dicesList.length >= 4){
                let skip = dicesList.length - 4;
                let count = 1;
                for (let i = 0; i < dicesList.length - 1; i++) {
                    let diff = dicesList[i+1] - dicesList[i];
                    if((diff == 0 || diff > 1) && count < 4){
                        if(skip > 0 && i == 0){
                            skip--;
                            continue;
                        }
                        return 0;
                    }else {
                        count++;
                    }
                }
            }else {
                return 0;
            }
            return 30;


            // if(!dices || dices.length == 0) return 0;
            //
            // //this is broken down into 2 parts
            // //part one checks to see if there is a number repeated more then twice
            // //then returns 0 because this is not a possible combo
            // //this part also finds the lowest number
            // //nCount finds duplicates
            // var nCount: number = 0
            // var nIsLowest = 0
            // //this will set the lowest number
            // var nLowestNumber = 0
            // //var nNoStraightCounter = 4
            // //this will keep track of a gap in a straight- there can only be one
            // var blnGap: Boolean = false;
            // //this is numbers compared to lowest +1 (+1, ect) that are found in the array
            // // if there are 3 of them (not including the lowest number or the gap number if the lowest isn't part of the straight) then return true
            // var nNumPassed = 0;
            // var hasDouble: Boolean = false;
            // var i: number;
            //
            // //don't know how to check this efficiantly
            // //so I start by checking for more then 2 duplicites
            // //in the proccess I am finding the lowest number
            // for (i = 0; i < 5; i++) {
            //     if (dices[i].value == dices[0].value) {
            //         nCount++
            //     }
            //     if (dices[i].value <= dices[0].value) {
            //         nIsLowest++
            //     }
            //     if (dices[i].value == dices[1].value) {
            //         nCount++
            //     }
            //     if (dices[i].value <= dices[1].value) {
            //         nIsLowest++
            //     }
            //     if (dices[i].value == dices[2].value) {
            //         nCount++
            //     }
            //     if (dices[i].value <= dices[2].value) {
            //         nIsLowest++
            //     }
            //     if (dices[i].value == dices[3].value) {
            //         nCount++
            //     }
            //     if (dices[i].value <= dices[3].value) {
            //         nIsLowest++
            //     }
            //     if (dices[i].value == dices[4].value) {
            //         nCount++
            //     }
            //     if (dices[i].value <= dices[4].value) {
            //         nIsLowest++
            //     }
            //
            //     if (nCount > 2) {
            //         return 0;
            //     }
            //     else if (nCount == 2) {
            //         hasDouble == true;
            //         nCount = 0;
            //     }
            //     else {
            //         nCount = 0;
            //     }
            //     if (nIsLowest == 5) {
            //         nLowestNumber = dices[i].value;
            //     }
            //     else {
            //         nIsLowest = 0;
            //     }
            // }
            //
            // //this is the second part of the function- it takes the lowest number and continues to add 1 and
            // //checks to see if there is a number in the array or it marks the gap
            //
            // //ok now that there are only 1 or no duplicates I take the lowest number
            // //and check to see if there is any +1 number
            // for (i = 0; i < 5; i++) {
            //     //increase the lowest number by 1
            //     nLowestNumber++;
            //     //if there are 3 passes- no need to continue
            //     if (blnGap && nNumPassed == 4) {
            //         return 30;
            //     }
            //     if (blnGap == false && nNumPassed == 3) {
            //         return 30;
            //     }
            //     if (nLowestNumber == (dices[0].value)) {
            //         nNumPassed++;
            //         //cool
            //     }
            //     else if (nLowestNumber == (dices[1].value)) {
            //         nNumPassed++;
            //         //cool
            //     }
            //     else if (nLowestNumber == (dices[2].value)) {
            //         nNumPassed++;
            //         //cool
            //     }
            //     else if (nLowestNumber == (dices[3].value)) {
            //         nNumPassed++;
            //         //cool
            //     }
            //     else if (nLowestNumber == (dices[4].value)) {
            //         //trace ("current lowest number +1 = " + (dices[4].value ))
            //         nNumPassed++;
            //         //cool
            //
            //     }
            //     else {
            //         if (blnGap == true || hasDouble == true) {
            //             return 0;
            //         }
            //         //ok since in some cases a 1 3 4 5 6 is legit
            //         //I add +1 to the lowest number and recheck
            //         nLowestNumber++;
            //         blnGap = true;
            //         if (nLowestNumber == (dices[0].value)) {
            //
            //             nNumPassed++;
            //             //cool
            //         }
            //         else if (nLowestNumber == (dices[1].value)) {
            //             nNumPassed++;
            //             //cool
            //         }
            //         else if (nLowestNumber == (dices[2].value)) {
            //             nNumPassed++;
            //             //cool
            //         }
            //         else if (nLowestNumber == (dices[3].value)) {
            //             nNumPassed++;
            //             //cool
            //         }
            //         else if (nLowestNumber == (dices[4].value)) {
            //             nNumPassed++;
            //             //cool
            //         }
            //         else {
            //             return 0;
            //
            //         }
            //     }
            // }
            // return 30

        }

        public checkColors(dices: Array<DiceData>): boolean {
            if(!dices || dices.length == 0) return false;

            for (var i: number = 0; i < 5; i++) {
                if (dices[i].color != dices[0].color) {
                    //there is no bonus dice
                    return false;
                }
            }

            //activate bonus roll
            return true;
        }

    }


}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/Model/Scoring/ScorePredictor.ts